<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Perfil Profissional' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <form [formGroup]="validations_form" (ngSubmit)="onSubmit()" [hidden]="!dadosPessoa">
    <ion-card>
      <ion-grid class="ion-margin-horizontal">
        <h1>Informações profissionais</h1>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Nome Completo' | translate}}</p>
            <p class="p-font">{{pessoaNome}}</p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Categoria Profissional' | translate}}</p>
            <p class="p-font">{{dadosPessoa?.nomeProfissao}}</p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Nome da Empresa' | translate}} <span class="danger">*</span></p>
            <input
              class="input-custom"
              type="text"
              formControlName="nome_empresa"
              placeholder="Digite o nome de sua empresa"
            />
          </ion-col>
          <ng-container *ngFor="let validation of validation_messages.nome_empresa">
            <ion-row *ngIf="validations_form.get('nome_empresa')?.invalid && submitted">
              <ion-col size="12">
                <ion-text color="danger"> {{ validation.message }} </ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-row>

        <ion-row class="ion-margin-vertical">
          <ion-col size="12">
            <p class="label-input-custom">{{'Descrição' | translate}} <span class="danger">*</span></p>
            <ion-textarea
              rows="5"
              class="text-area"
              placeholder="{{'Descreva seus serviços' | translate}}"
              maxlength="180"
              style="--padding-start: 8px"
              formControlName="descricao"
            ></ion-textarea>
          </ion-col>
          <ng-container *ngFor="let validation of validation_messages.descricao">
            <ion-row *ngIf="validations_form.get('descricao')?.invalid && submitted">
              <ion-col size="12">
                <ion-text color="danger"> {{ validation.message }} </ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <div class="input-tel">
              <p class="label-input-custom">{{'Telefone' | translate}} <span class="danger">*</span></p>
              <input
                class="input-custom"
                type="tel"
                #phoneInput
                [mask]="maskTel"
                formControlName="telComercial"
                placeholder="(41)99999-9999"
              />
            </div>
          </ion-col>
          <ng-container *ngFor="let validation of validation_messages.telComercial">
            <ion-row *ngIf="validations_form.get('telComercial')?.invalid && submitted">
              <ion-col size="12">
                <ion-text color="danger"> {{ validation.message }} </ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <ion-toggle
              class="label-input-custom"
              style="width: 100%"
              [enableOnOffLabels]="true"
              formControlName="whatsappComercial"
              labelPlacement="start"
            >
              {{'Contato possui whatsApp?' | translate}}
            </ion-toggle>
          </ion-col>
        </ion-row>

        <h1>Redes Sociais</h1>

        <ion-row class="ion-margin-vertical">
          <ion-col size="12">
            <p class="label-input-custom">{{'E-mail' | translate}}</p>
            <ion-input
              type="email"
              class="input-custom"
              placeholder="Digite um E-mail de Contato"
              formControlName="email"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Website' | translate}}</p>
            <ion-input
              type="url"
              class="input-custom"
              placeholder="www.seusite.com.br"
              formControlName="site"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Linkedin' | translate}}</p>
            <ion-input
              type="url"
              class="input-custom"
              placeholder="url linkedin"
              formControlName="linkedin"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Instagram' | translate}}</p>
            <ion-input
              type="url"
              class="input-custom"
              placeholder="URL @instagram"
              formControlName="instagram"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12">
            <p class="label-input-custom">{{'Facebook' | translate}}</p>
            <ion-input
              type="url"
              class="input-custom"
              placeholder="url facebook"
              formControlName="facebook"
            ></ion-input>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>

    <ion-button expand="block" class="btn-default ion-margin" type="submit"> {{'Salvar'}} </ion-button>
  </form>

  <div class="ion-margin-horizontal">
    <sem-registro
      *ngIf="!dadosPessoa"
      text="Categoria profissional não informada. Para definir sua profissão, entre em contato com a instituição"
    ></sem-registro>
  </div>
</ion-content>
